import { useMemo } from 'react';
import type { BranchAccess, ModuleKey } from '../store/useSessionStore';
import { useSessionStore } from '../store/useSessionStore';

/**
 * Resuelve permisos desde el estado de sucursales (misma fuente que la UI de selector / tarjetas).
 * Usar esto para gates de navegación; el default debe ser denegado si falta la fila del módulo.
 */
export function resolveBranchModulePermission(
  branches: BranchAccess[],
  branchId: string | undefined,
  module: ModuleKey
): {
  canView: boolean;
  canEdit: boolean;
  canVoid: boolean;
  canDiscount: boolean;
  canManageAgenda: boolean;
  canViewOthers: boolean;
  actions: Record<string, boolean>;
  branchName: string;
} {
  const branch = branchId ? branches.find((item) => item.id === branchId) : undefined;
  const permission = branch?.permissions.find((item) => item.module === module);
  return {
    canView: permission?.canView ?? false,
    canEdit: permission?.canEdit ?? false,
    canVoid: permission?.canVoid ?? false,
    canDiscount: permission?.canDiscount ?? false,
    canManageAgenda: permission?.canManageAgenda ?? false,
    canViewOthers: permission?.canViewOthers ?? true,
    actions: permission?.actions ?? {},
    branchName: branch?.name ?? branchId ?? 'Sucursal sin seleccionar',
  };
}

export const useBranchPermission = (module: ModuleKey) => {
  const currentBranchId = useSessionStore((state) => state.currentBranchId);
  const branches = useSessionStore((state) => state.branches);

  return useMemo(
    () => resolveBranchModulePermission(branches, currentBranchId, module),
    [branches, currentBranchId, module]
  );
};
